import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllExams = () => apiClient.get(ENDPOINTS.EXAM.BASE);

export const getExamById = (id) => apiClient.get(`${ENDPOINTS.EXAM.BASE}/${id}`);

export const getExamAndScheduleById = (id) => apiClient.get(ENDPOINTS.EXAM.SINGLE(id));

export const createExam = (examData) => apiClient.post(ENDPOINTS.EXAM.BASE, examData);

export const updateExam = (id, examData) => apiClient.put(`${ENDPOINTS.EXAM.BASE}/${id}`, examData);

export const deleteExam = (id) => apiClient.delete(`${ENDPOINTS.EXAM.BASE}/${id}`);
